module.exports = __webpack_public_path__ + "static/media/Icon_Serious_Incidents_Opacity70.0e87df41.png";